import { InvitationRecipientApiResponse } from "@resources/InvitationRecipient.apiResponse";

export class InvitationRecipientViewModel {
  id: string;
  phone: string;
  email: string;
  languageId: string;

  constructor(invitationRecipientApiResponse: InvitationRecipientApiResponse) {
    this.id = invitationRecipientApiResponse.id;
    this.phone = invitationRecipientApiResponse.profile.phone;
    this.email = invitationRecipientApiResponse.profile.email;
    this.languageId = invitationRecipientApiResponse.profile.languageId;
  }
}
